
import { Portal, Spinner, makeStyles, tokens } from "@fluentui/react-components";
import { useState } from "react";

const buildStyles = makeStyles({
    overlay: {
        backgroundColor: tokens.colorBackgroundOverlay,
        opacity: 0.5,
        position: 'fixed',
        top: '0px',
        left: '0px',
        bottom: '0px',
        width: '100%',
        zIndex: 1000
    },
    spinner: {
        opacity: 1,
        zIndex: 1000,
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translateX(-50%)'
    },
    normal: {
        marginTop: '10px',
        marginBottom: '10px',
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    }
});

export function ProgressOverlay() {
    const styles = buildStyles();
    const [rootElement, setRootElement] = useState<HTMLElement | null>(null);
    return (
        <>
            <Portal mountNode={rootElement}>
                <div className={styles.overlay}></div>
                <div className={styles.spinner}>
                    <section className={styles.normal}>
                        <Spinner size='medium' labelPosition='below' />
                    </section>
                </div>
            </Portal>
            <div ref={setRootElement} />
        </>
    );
}